import {
  Box,
  Button,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from '@mui/material';
import React, { useState, useContext } from 'react';
import BuyerWinnerImage from 'assets/images/BuyerWinnerImage.png';
import { POST_AGENT_BANNER_CLOSE } from 'constant/app.config';
import { postApiCall } from 'api/apiService';
import { datacontext } from 'modules/AppLayout/AppLayout';

const CongratulationSettlementCompleted = (props) => {
  let {
    setCongratulationsettlementClose,
    bannerDetails,
    isAgentDashboard,
    getListInfo,
    AgentGroupCall,
  } = props;
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const { bannerApiTrigger } = useContext(datacontext);

  const [closeLoader, setCloseLoader] = useState(false);
  const propertyId = Number(bannerDetails?.propertyId);

  const handleSettlementCompletedCloseApiCall = async () => {
    let input = {
      propertyId: propertyId,
      bannerCode: 'AGENT005',
      bannerHeading: 'Congratulations Settlement Completed',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_AGENT_BANNER_CLOSE, input);
      bannerApiTrigger();

      if (response?.data?.status == 1) {
        setCongratulationsettlementClose((prev) =>
          prev.includes(propertyId) ? prev : [...prev, propertyId]
        );
        if (!isAgentDashboard) {
          getListInfo();
        }
        if (isAgentDashboard) {
          AgentGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: '14px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    marginTop: matchessm && '-40px',
                  }}
                >
                  {bannerDetails?.propertyAddress}.
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Congratulations Settlement Completed
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  Verify settlement has completed successfully for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 600 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.propertyAddress}
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  mt={matchessm ? 9 : 2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    onClick={() => {
                      setCloseLoader(true);
                      handleSettlementCompletedCloseApiCall();
                    }}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                    disabled={closeLoader} // prevent double click
                  >
                    {closeLoader ? (
                      <CircularProgress size={20} sx={{ color: '#E6F2FF' }} />
                    ) : (
                      'Close'
                    )}
                  </Button>
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={BuyerWinnerImage}
                alt="BuyerWinnerImage"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default CongratulationSettlementCompleted;
